import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@diggens/api-client';
import type { TenantSchema } from '@diggens/types/apps';

export const TENANT_SCHEMA_QUERY_KEY = ['tenant-schema'] as const;

/**
 * The caller's merged tenant schema from GET /schema: the compiled registries plus the tenant's active app manifests.
 * Fetch it once a user is signed in; the CRM's SchemaProvider overlays it on the registry lookups.
 */
export function useTenantSchema(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: TENANT_SCHEMA_QUERY_KEY,
    queryFn: () => apiFetch<TenantSchema>('/schema'),
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000,
  });
}
